import {
  SmartPairedBayBlock,
  SmartUnpairedBayBlock,
  TIContainerInformationExtendedValid,
} from "@tedivo/tedivo-bay-grid-pure";

import { BayLevelEnum } from "open-vessel-definition";
import { TGetContainersFilterOutput } from "./TGetContainersFilterOutput";

export function getContainersByHighestBelow(
  smartBay: SmartUnpairedBayBlock | SmartPairedBayBlock,
): TGetContainersFilterOutput {
  const containers: TIContainerInformationExtendedValid[] = [];

  // Only process below deck containers
  if (smartBay.level !== BayLevelEnum.BELOW) {
    return {
      containers,
      tBaysStr: smartBay.tBaysStr,
      level: smartBay.level,
    };
  }

  const { gridContent, allStacksKeys, allTiersKeys } = smartBay.getGridContent();

  // For each stack, get the highest container below deck
  for (const stackKey of allStacksKeys) {
    const tiersInStack = allTiersKeys.filter((tier) => gridContent[stackKey]?.[tier]);

    if (tiersInStack.length === 0) continue;

    // Sort tiers from bottom to top and get the highest (last)
    const sortedTiers = tiersInStack.sort();
    const highestTier = sortedTiers[sortedTiers.length - 1];

    const content = gridContent[stackKey]?.[highestTier];
    if (content) {
      containers.push(...(content.containers as TIContainerInformationExtendedValid[]));
    }
  }

  return {
    containers,
    tBaysStr: smartBay.tBaysStr,
    level: smartBay.level,
  };
}
